<template>
    <el-button type="success" size="small" circle>
        <ComTooltip content="Lisää">
            <el-icon>
                <Plus></Plus>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { Plus } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Plus,
        ComTooltip,
    },
})
</script>
